<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="visitCode"
    >
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <b-button variant="light"><i class="el-icon-more"></i></b-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-view"
                :command="'viewVisit:' + row.visitCode"
                >{{
                  $l('table_visit_btn_view') || '查看拜访记录'
                }}</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-check"
                divided
                :command="'applyVisit:' + row.visitCode"
                >{{
                  $l('table_visit_btn_apply') || '提交报销申请'
                }}</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-postcard"
                divided
                :command="'editVisit:' + row.visitCode"
                >{{
                  $l('table_visit_btn_edit') || '编辑拜访记录'
                }}</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-edit-outline"
                divided
                :command="'editRating:' + row.visitCode + ',' + row.scmCode"
                >{{
                  $l('table_visit_btn_rating') || '编辑供应商评分'
                }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:scmName="{ row }">
        <div>
          <el-link
            :underline="false"
            type="primary"
            @click="viewScmDetail(row.scmCode)"
          >
            {{ row.scmName }}
          </el-link>
        </div>
      </template>
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center" class="mt-5">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      ref="scoreTemplateDialog"
      @opened="scoreTemplateDialogOpened"
      :title="$l('tips_choice_scoreTemplate') || '选择评分模板'"
      :visible.sync="formOption.dialogFormVisible"
      :close-on-click-modal="false"
      width="740px"
    >
      <score-template
        ref="scoreTemplate"
        @success="choiceScoreTemplateSuccess"
        @cancel="choiceScoreTemplateCancel"
      ></score-template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {
    ScoreTemplate: () => import('../rating/scoreTemplate'),
  },
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
        custom: true,
      },
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
      },
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          fixed: 'left',
          headerAlign: 'center',
          align: 'center',
          type: 'seq',
        },
        {
          field: 'visitDate',
          headerAlign: 'left',
          align: 'left',
          width: 150,
          title: this.$l('visit_label_visitDate') || '拜访日期',
          showHeaderOverflow: 'title',
        },
        {
          field: 'scmName',
          headerAlign: 'left',
          align: 'left',
          minWidth: 300,
          title: this.$l('table_hand_nameOfManufacturer') || '厂商名称',
          showHeaderOverflow: 'title',
          slots: {
            default: 'scmName',
          },
        },
        {
          field: 'visitTitle',
          headerAlign: 'left',
          align: 'left',
          minWidth: 350,
          title: this.$l('visit_label_visitTitle') || '拜访目的',
          showHeaderOverflow: 'title',
        },
        {
          field: 'visitPerson',
          headerAlign: 'left',
          align: 'left',
          minWidth: 300,
          title: this.$l('visit_label_Visitors') || '访问人员',
          showHeaderOverflow: 'title',
        },
        
        {
          field: 'scmPerson',
          headerAlign: 'left',
          align: 'left',
          minWidth: 300,
          title: this.$l('visit_form_label_manufacturer') || '厂商人员',
          showHeaderOverflow: 'title',
        },
        {
          field: 'createByName',
          align: 'center',
          width: 120,
          title: this.$l('INDEX.creator') || '创建人',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          field: 'createTime',
          align: 'center',
          width: 170,
          title: this.$l('INDEX.table_label_created_date') || '创建时间',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          field: 'modifyByName',
          align: 'center',
          width: 120,
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          field: 'modifyTime',
          align: 'center',
          width: 170,
          title: this.$l('INDEX.table_label_modification_date') || '修改时间',
          showHeaderOverflow: 'title',
          showOverflow: true,
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 90,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
      ],
      curVisitCode: '',
      curScmCode: '',
    }
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 175
    },
    viewScmDetail(val) {
      this.$router.push({
        name: 'resourceManagement-scmInfoDetail',
        params: {
          scmCode: val,
        },
      })
    },
    reload() {
      this.$emit('reload')
    },
    handleCommand(command) {
      let type = (command || '').split(':')[0]
      let code = (command || '').split(':')[1]
      if (type === 'viewVisit') {
        this.viewMyVisit('view', code)
      } else if (type === 'editVisit') {
        this.editMyVisit('edit', code)
      } else if (type === 'editRating') {
        this.openRating('edit', code)
      } else if (type === 'applyVisit') {
        this.applyVisit('apply', code)
      }
    },
    viewMyVisit(type, val) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-view',
        params: {
          pageType: type,
          visitCode: val,
        },
      })
    },
    editMyVisit(type, val) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-edit',
        params: {
          pageType: type,
          visitCode: val,
        },
      })
    },
    openRating(type, val) {
      this.curVisitCode = (val || '').split(',')[0]
      this.curScmCode = (val || '').split(',')[1]

      // 查询本次拜访的评分记录
      let param = { visitCode: this.curVisitCode }
      this.$api.scmInfoVisitScoreApi(param).then((res) => {
        if (res.body) {
          this.editRating('edit', res.body.visitScoreCode)
        } else {
          // 弹出窗口选择模板，并新增
          this.choiceScoreTemplate()
        }
      })
    },
    editRating(type, val) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-rating-edit',
        params: {
          pageType: type,
          visitScoreCode: val,
        },
      })
    },
    applyVisit(type, val) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-edit',
        params: {
          pageType: type,
          visitCode: val,
        },
      })
    },
    choiceScoreTemplate() {
      this.formOption.dialogFormVisible = true
    },
    scoreTemplateDialogOpened() {
      this.$refs.scoreTemplate.init()
    },
    choiceScoreTemplateSuccess(val) {
      let appraisalBillCode = val.appraisalBillCode
      let param = {
        scmCode: this.curScmCode,
        visitCode: this.curVisitCode,
        appraisalBillCode: appraisalBillCode,
      }
      this.$api.addVisitScoreApi(param).then((res) => {
        let visitScoreCode = res.body
        this.editRating('edit', visitScoreCode)
      })

      this.formOption.dialogFormVisible = false
    },
    choiceScoreTemplateCancel() {
      this.formOption.dialogFormVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.table-text {
  color: #6c757d;
  font-size: 14.4px;
}
</style>
